export function sourcePaperName(record = {}, provenance) {
  const sourceKey=String(record.source_file || '').replace(/^\d+_/, '');
  const confirmed=provenance?.paper_names?.[record.source_file] || provenance?.paper_names?.[sourceKey];
  if (confirmed) return confirmed;
  if (record.paper_name) return record.paper_name;
  const source = record.source_file;
  if (!source) return 'Not reported';
  const named = provenance?.relationships?.find(row => row.source_file === source && row.paper_name);
  if (named) return named.paper_name;
  const document = provenance?.source_manifest?.documents?.find(row => row.source_file === source);
  if (document?.paper_name || document?.title) return document.paper_name || document.title;
  return source.replace(/^.*[/\\]/, '').replace(/^\d+_/, '').replace(/\.(?:txt|pdf)$/i, '').replace(/-merged$/i, '').replace(/_/g, ' ');
}
